module.exports = __webpack_public_path__ + "img/logo-15.53127bec.png";